const initialState = {
  resultsHealthSafetyRestrictionsList: [],
  resultsHealthSafetyRestriction: {},
  resultsHealthSafetyRestrictionAdd: {},
  resultsHealthSafetyRestrictionEdit: {},
  resultsHealthSafetyRestrictionDelete: {},
  resultsHealthSafetyRestrictionProductAdd: {},
  resultsHealthSafetyRestrictionProductsDelete: {},
  resultsHealthSafetyRestrictionsProductAdd: {},
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_HEALTH_SAFETY_RESTRICTIONS_RESPONSE_GET":
      newState.resultsHealthSafetyRestrictionsList = action.value;
      break;
    case "HEALTH_SAFETY_RESTRICTION_RESPONSE_GET":
      newState.resultsHealthSafetyRestriction = action.value;
      break;
    case "HEALTH_SAFETY_RESTRICTION_RESPONSE_ADD":
      newState.resultsHealthSafetyRestrictionAdd = action.value;
      break;
    case "HEALTH_SAFETY_RESTRICTION_RESPONSE_EDIT":
      newState.resultsHealthSafetyRestrictionEdit = action.value;
      break;
    case "HEALTH_SAFETY_RESTRICTION_RESPONSE_DELETE":
      newState.resultsHealthSafetyRestrictionDelete = action.value;
      break;
    case "HEALTH_SAFETY_RESTRICTION_PRODUCT_RESPONSE_ADD":
      newState.resultsHealthSafetyRestrictionProductAdd = action.value;
      break;
    case "HEALTH_SAFETY_RESTRICTION_PRODUCTS_RESPONSE_DELETE":
      newState.resultsHealthSafetyRestrictionProductsDelete = action.value;
      break;
    case "HEALTH_SAFETY_RESTRICTIONS_PRODUCT_RESPONSE_ADD":
      newState.resultsHealthSafetyRestrictionsProductAdd = action.value;
      break;
    case "HEALTH_SAFETY_RESTRICTIONS_PRODUCT_RESPONSE_DELETE":
      newState.resultsHealthSafetyRestrictionsProductDelete = action.value;
      break;
    case "RESET_HEALTH_SAFETY_RESTRICTION_RESPONSES":
      newState.resultsHealthSafetyRestrictionAdd = {};
      newState.resultsHealthSafetyRestrictionEdit = {};
      newState.resultsHealthSafetyRestrictionDelete = {};
      newState.resultsHealthSafetyRestrictionProductAdd = {};
      newState.resultsHealthSafetyRestrictionProductsDelete = {};
      newState.resultsHealthSafetyRestrictionsProductAdd = {};
      newState.resultsHealthSafetyRestrictionsProductDelete = {};
      newState.resultsHealthSafetyRestriction = {};
      newState.resultsHealthSafetyRestrictionsList = {};
      break;
    default:
      break;
  }
  return newState;
};

export default reducer;
